import { inject, Inject, Injectable } from '@angular/core';

import { ORG_GUID, TellentAdminAppConfig } from '@tellent/types';

import { APP_CONFIG, AUTH_METHOD, AUTH_TOKEN } from '@recruitee/common';
import { HttpApiRequestOptions, HttpRequestData, IdentityHeaders } from '@recruitee/http';

@Injectable({ providedIn: 'root' })
export class TellentAdminRequestData extends HttpRequestData {
  private orgGuid = inject(ORG_GUID);
  private authMethod = inject(AUTH_METHOD);
  private authToken = inject(AUTH_TOKEN);
  constructor(@Inject(APP_CONFIG) private config: TellentAdminAppConfig) {
    super();
  }
  public buildUrl(path: string, requestOptions: HttpApiRequestOptions): string {
    return `${this.config.tellentApiUrl}${
      requestOptions.skipCompany ? '' : '/api/org/' + this.orgGuid
    }${path}`;
  }

  public provideAuthHeaders(): { Authorization: string } {
    return { Authorization: `${this.authMethod} ${this.authToken}` };
  }

  public provideIdentityHeaders(): IdentityHeaders {
    return {};
  }
}
